/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewings_Reason_NoteInputs */

const cs_viewings_reason_note = /** @type {(inputs: Viewings_Reason_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poznámka k důvodu`)
};

const en_viewings_reason_note = /** @type {(inputs: Viewings_Reason_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reason note`)
};

/**
* | output |
* | --- |
* | "Reason note" |
*
* @param {Viewings_Reason_NoteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const viewings_reason_note = /** @type {((inputs?: Viewings_Reason_NoteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewings_Reason_NoteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewings_reason_note(inputs)
	return cs_viewings_reason_note(inputs)
});